import { Component } from '@angular/core';
import { PageContainerComponent } from '@unity/layouts/page-container/page-container.component';
import { ActionSharedComponent } from '@unity/shared/composed/action-shared/action-shared.component';
import { GridAgencySharedComponent } from '@unity/shared/grid-agency-shared/grid-agency-shared.component';
import { QuickActions } from '@unity/utils/quick-actions';

@Component({
  selector: 'unity-list-agency-page',
  standalone: true,
  imports: [PageContainerComponent, GridAgencySharedComponent, ActionSharedComponent],
  templateUrl: './list-agency-page.component.html',
  styleUrl: './list-agency-page.component.scss',
})
export class ListAgencyPageComponent {
  protected createBusinessPartnerAction = QuickActions.CreateBusinessPartner;

  protected returnToDashboardAction = QuickActions.ReturnToDashboard;
}
